<script>
export default {
  props: {
    module: Object,
  },
};
</script>
<template>
  <CardBody v-if="module && module.show" :html="module.html"/>
</template>
